// extracted by mini-css-extract-plugin
export default {"textareaContainer":"main-textarea_textareaContainer__Ph3bw","placeholder":"main-textarea_placeholder__zrHFe","textarea":"main-textarea_textarea__bqHv6"};